import { render, staticRenderFns } from "./CobranzaVidaAhorro.vue?vue&type=template&id=3e0e0e9a"
import script from "./CobranzaVidaAhorro.vue?vue&type=script&lang=js"
export * from "./CobranzaVidaAhorro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports